module.exports = __webpack_public_path__ + "416ee793150555634465c8d37eadc2ba.svg";